export enum Access {
  NONE = 0,
  SHARED = 1,
  FULL = 2
}

export function canAccess(desiredAccess: Access, currentAccess: Access): boolean {
  return currentAccess >= desiredAccess
}

export function isAccess(desiredAccess: Access, currentAccess: Access): boolean {
  return currentAccess === desiredAccess
}

export function useAccess() {
  return {
    access: Access,
    canAccess,
    isAccess
  }
}
